// import { Addon } from "@apis/index";
// import Button from "@components/button";
// import Column from "@components/column";
// import Fields from "@components/fields";
// import Row from "@components/row";
// import { Form, Formik } from "formik";
// import { Plus, X } from "lucide-react";
// import React, { Fragment, useCallback, useEffect, useState } from "react";
// import Lenscolor from "./Lenscolor";
// import { useSearchParams } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { RootState } from "@store/index";

// const CommonForm = ({ name, type }: any) => {
//   const { data: addons } = useSelector((state: RootState) => state.addons);
//   const [lensColorData, setLensColorData] = useState(null);
//   console.log(addons);
//   const fetchAddons = useCallback(async () => {
//     await Addon.find({ state: "addons", params: { type } });
//   }, [type]);
//   useEffect(() => {
//     fetchAddons();
//   }, [fetchAddons, type]);

//   const [initialValues, setInitialValues] = useState({
//     [`${name}-image`]: "",
//     [`${name}-sections`]: [{ title: "", price: "", description: "" }],
//   });

//   useEffect(() => {
//     if (addons?.id && addons?.type === type) {
//       setInitialValues({
//         [`${name}-image`]: addons.image || "",
//         [`${name}-sections`]: Array.isArray(addons?.options)
//           ? addons.options.map(({ id, price, title, description }) => ({
//               id,
//               price: price?.toString() || "",
//               title: title || "",
//               description: description || "",
//             }))
//           : [{ title: "", price: "", description: "" }],
//       });
//     } else {
//       setInitialValues({
//         [`${name}-image`]: "",
//         [`${name}-sections`]: [{ title: "", price: "", description: "" }],
//       });
//     }
//   }, [addons, name]);
//   const handleSubmit = async (values) => {
//     const formData = new FormData();
//     formData.append("type", type);

//     if (values[`${name}-image`]?.rawFile) {
//       formData.append("image", values[`${name}-image`].rawFile);
//     }

//     values[`${name}-sections`].forEach((section, index) => {
//       if (section.id) {
//         formData.append(`options[${index}][id]`, section.id);
//       }
//       formData.append(`options[${index}][title]`, section.title);
//       formData.append(`options[${index}][description]`, section.description);
//       formData.append(`options[${index}][price]`, section.price);
//     });

//     if (type === "Lens Color" && lensColorData) {
//       const { normals = [], polarized = [] } = lensColorData;

//       normals.forEach((normal, index) => {
//         if (normal.id) {
//           formData.append(`normals[${index}][id]`, normal.id);
//         }
//         if (normal.color) {
//           formData.append(`normals[${index}][color]`, normal.color);
//         }
//         if (normal.price) {
//           formData.append(`normals[${index}][price]`, normal.price);
//         }
//       });

//       polarized.forEach((polar, index) => {
//         if (polar.id) {
//           formData.append(`polarizeds[${index}][id]`, polar.id);
//         }
//         if (polar.color) {
//           formData.append(`polarizeds[${index}][color]`, polar.color);
//         }
//         if (polar.price) {
//           formData.append(`polarizeds[${index}][price]`, polar.price);
//         }
//       });
//     }

//     await Addon.create({ state: "addons", data: formData });
//   };
//   // const handleSubmit = async (values) => {
//   //   const formData = new FormData();
//   //   formData.append("type", type);
//   //   if (values[`${name}-image`].rawFile)
//   //     formData.append("image", values[`${name}-image`].rawFile);
//   //   values[`${name}-sections`].forEach((section, index) => {
//   //     if (section.id) {
//   //       formData.append(`options[${index}][id]`, section.id);
//   //     }
//   //     formData.append(`options[${index}][title]`, section.title);
//   //     formData.append(`options[${index}][description]`, section.description);
//   //     formData.append(`options[${index}][price]`, section.price);
//   //   });
//   //   if (type === "Lens Type") {
//   //     normals.forEach((normal) => {});
//   //     polarized.forEach((polarized) => {});
//   //   }
//   //   await Addon.create({ state: "addons", data: formData });
//   // };

//   return (
//     <Fragment>
//       <Formik
//         initialValues={initialValues}
//         onSubmit={handleSubmit}
//         key={name}
//         enableReinitialize={true}
//       >
//         {({ values, setFieldValue }) => (
//           <Form>
//             <Column>
//               {/* Image Section */}
//               <div style={{ padding: "16px 0" }}>
//                 <Fields.Upload
//                   name={`${name}-image`}
//                   label="Image"
//                   placeholder="Add Image"
//                   useRawFile={true}
//                 />
//               </div>

//               {/* Dynamic Form Sections */}
//               {values[`${name}-sections`]?.map((section, index) => (
//                 <div
//                   key={index}
//                   style={{
//                     backgroundColor: "#f8f9fa",
//                     padding: "20px",
//                     borderRadius: "12px",
//                     border: "1px solid #e9ecef",
//                     position: "relative",
//                   }}
//                 >
//                   {/* Section Header with Remove Button */}
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       marginBottom: "16px",
//                     }}
//                   >
//                     <h4
//                       style={{
//                         margin: 0,
//                         color: "#495057",
//                         fontSize: "16px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       Item {index + 1}
//                     </h4>

//                     {values[`${name}-sections`].length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() => {
//                           const newSections = values[`${name}-sections`].filter(
//                             (_, i) => i !== index
//                           );
//                           setFieldValue(`${name}-sections`, newSections);
//                         }}
//                         style={{
//                           background: "none",
//                           border: "none",
//                           cursor: "pointer",
//                           color: "#dc3545",
//                           padding: "4px",
//                           borderRadius: "4px",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <X size={18} />
//                       </button>
//                     )}
//                   </div>

//                   <Row>
//                     <div style={{ flex: 1 }}>
//                       <Column stylecolumn="row-gap:10px">
//                         <Fields.Input
//                           name={`${name}-sections[${index}].title`}
//                           placeholder="Enter title"
//                           label="Title"
//                         />
//                         <Fields.Input
//                           name={`${name}-sections[${index}].price`}
//                           placeholder="Enter price"
//                           label="Price"
//                           type="number"
//                         />
//                       </Column>
//                     </div>
//                     <div style={{ flex: 1 }}>
//                       <Fields.TextArea
//                         name={`${name}-sections[${index}].description`}
//                         placeholder="Enter description"
//                         label="Description"
//                         rows={4}
//                       />
//                     </div>
//                   </Row>
//                 </div>
//               ))}

//               {/* Action Buttons */}
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   paddingTop: "16px",
//                   borderTop: "1px solid #e9ecef",
//                 }}
//               >
//                 {/* Add More Button */}
//                 <button
//                   type="button"
//                   onClick={() => {
//                     const newSections = [
//                       ...values[`${name}-sections`],
//                       { title: "", price: "", description: "" },
//                     ];
//                     setFieldValue(`${name}-sections`, newSections);
//                   }}
//                   style={{
//                     background: "none",
//                     border: "1px dashed #6c757d",
//                     color: "#6c757d",
//                     cursor: "pointer",
//                     padding: "8px 16px",
//                     borderRadius: "6px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   <Plus size={16} />
//                   Add Another Item
//                 </button>

//                 <Button
//                   title={addons.type === type ? "Update" : "Save"}
//                   type="submit"
//                 />
//               </div>
//             </Column>
//           </Form>
//         )}
//       </Formik>
//       <br />
//       {type === "Lens Color" && (
//         <Lenscolor
//           setLensColorData={setLensColorData}
//           existingData={addons?.type === type ? addons : null}
//         />
//       )}
//     </Fragment>
//   );
// };

// export default CommonForm;

import { Addon } from "@apis/index";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import { Form, Formik } from "formik";
import { Plus, X } from "lucide-react";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import Lenscolor from "./Lenscolor";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";

const CommonForm = ({ name, type }: any) => {
  const { data: addons } = useSelector((state: RootState) => state.addons);
  const [lensColorData, setLensColorData] = useState(null);
  console.log(addons);
  const fetchAddons = useCallback(async () => {
    await Addon.find({ state: "addons", params: { type } });
  }, [type]);
  useEffect(() => {
    fetchAddons();
  }, [fetchAddons, type]);

  const [initialValues, setInitialValues] = useState({
    [`${name}-image`]: "",
    [`${name}-sections`]: [{ title: "", price: "", description: "" }],
  });

  useEffect(() => {
    if (addons?.id && addons?.type === type) {
      setInitialValues({
        [`${name}-image`]: addons.image || "",
        [`${name}-sections`]: Array.isArray(addons?.options)
          ? addons.options.map(({ id, price, title, description }) => ({
              id,
              price: price?.toString() || "",
              title: title || "",
              description: description || "",
            }))
          : [{ title: "", price: "", description: "" }],
      });
    } else {
      setInitialValues({
        [`${name}-image`]: "",
        [`${name}-sections`]: [{ title: "", price: "", description: "" }],
      });
    }
  }, [addons, name]);

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("type", type);

    if (values[`${name}-image`]?.rawFile) {
      formData.append("image", values[`${name}-image`].rawFile);
    }

    values[`${name}-sections`].forEach((section, index) => {
      if (section.id) {
        formData.append(`options[${index}][id]`, section.id);
      }
      formData.append(`options[${index}][title]`, section.title);
      formData.append(`options[${index}][description]`, section.description);
      formData.append(`options[${index}][price]`, section.price);
    });

    if (type === "Lens Color" && lensColorData) {
      const { normals = [], polarized = [] } = lensColorData;

      normals.forEach((normal, index) => {
        if (normal.id) {
          formData.append(`normals[${index}][id]`, normal.id);
        }
        if (normal.color) {
          formData.append(`normals[${index}][color]`, normal.color);
        }
        if (normal.price) {
          formData.append(`normals[${index}][price]`, normal.price);
        }
      });

      polarized.forEach((polar, index) => {
        if (polar.id) {
          formData.append(`polarizeds[${index}][id]`, polar.id);
        }
        if (polar.color) {
          formData.append(`polarizeds[${index}][color]`, polar.color);
        }
        if (polar.price) {
          formData.append(`polarizeds[${index}][price]`, polar.price);
        }
      });
    }

    await Addon.create({ state: "addons", data: formData }).then(() => {
      if (type === "Lens Color") {
        window.location.reload();
      }
    });
  };

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        key={name}
        enableReinitialize={true}
      >
        {({ values, setFieldValue, submitForm }) => (
          <Form>
            <Column>
              {/* Image Section */}
              <div style={{ padding: "16px 0" }}>
                <Fields.Upload
                  name={`${name}-image`}
                  label="Image"
                  placeholder="Add Image"
                  useRawFile={true}
                />
              </div>

              {/* Dynamic Form Sections */}
              {values[`${name}-sections`]?.map((section, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#f8f9fa",
                    padding: "20px",
                    borderRadius: "12px",
                    border: "1px solid #e9ecef",
                    position: "relative",
                  }}
                >
                  {/* Section Header with Remove Button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        color: "#495057",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Item {index + 1}
                    </h4>

                    {values[`${name}-sections`].length > 1 && (
                      <button
                        type="button"
                        onClick={() => {
                          const newSections = values[`${name}-sections`].filter(
                            (_, i) => i !== index
                          );
                          setFieldValue(`${name}-sections`, newSections);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#dc3545",
                          padding: "4px",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <X size={18} />
                      </button>
                    )}
                  </div>

                  <Row>
                    <div style={{ flex: 1 }}>
                      <Column stylecolumn="row-gap:10px">
                        <Fields.Input
                          name={`${name}-sections[${index}].title`}
                          placeholder="Enter title"
                          label="Title"
                        />
                        <Fields.Input
                          name={`${name}-sections[${index}].price`}
                          placeholder="Enter price"
                          label="Price"
                          type="number"
                        />
                      </Column>
                    </div>
                    <div style={{ flex: 1 }}>
                      <Fields.TextArea
                        name={`${name}-sections[${index}].description`}
                        placeholder="Enter description"
                        label="Description"
                        rows={4}
                      />
                    </div>
                  </Row>
                </div>
              ))}

              {/* Add More Button (only for non-Lens Color types) */}
              {type !== "Lens Color" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingTop: "16px",
                    borderTop: "1px solid #e9ecef",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      const newSections = [
                        ...values[`${name}-sections`],
                        { title: "", price: "", description: "" },
                      ];
                      setFieldValue(`${name}-sections`, newSections);
                    }}
                    style={{
                      background: "none",
                      border: "1px dashed #6c757d",
                      color: "#6c757d",
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    <Plus size={16} />
                    Add Another Item
                  </button>

                  <Button
                    title={addons?.type === type ? "Update" : "Save"}
                    type="submit"
                  />
                </div>
              )}
            </Column>

            {/* Lens Color Component */}
            {type === "Lens Color" && (
              <>
                <br />
                <Lenscolor
                  setLensColorData={setLensColorData}
                  existingData={addons?.type === type ? addons : null}
                />

                {/* Main Save/Update Button for Lens Color at the bottom */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    paddingTop: "24px",
                    marginTop: "24px",
                    borderTop: "2px solid #e9ecef",
                    position: "sticky",
                    bottom: "0",
                    background: "white",
                    padding: "16px 0",
                  }}
                >
                  <div style={{ display: "flex", gap: "12px" }}>
                    {/* Add More Button for Lens Color form sections */}
                    <button
                      type="button"
                      onClick={() => {
                        const newSections = [
                          ...values[`${name}-sections`],
                          { title: "", price: "", description: "" },
                        ];
                        setFieldValue(`${name}-sections`, newSections);
                      }}
                      style={{
                        background: "none",
                        border: "1px dashed #6c757d",
                        color: "#6c757d",
                        cursor: "pointer",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      <Plus size={16} />
                      Add Another Item
                    </button>

                    <Button
                      title={
                        addons?.type === type
                          ? "Update Configuration"
                          : "Save Configuration"
                      }
                      type="submit"
                    />
                  </div>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

export default CommonForm;
